// Auto-generated theme: compact
export default {
    '--sjs2-base-unit-size': '8px',
    '--sjs2-base-unit-spacing': '8px',
    '--sjs2-base-unit-radius': '8px',
    '--sjs2-base-unit-border-width': '1px',
    '--sjs2-base-unit-font-size': '8px',
    '--sjs2-base-unit-line-height': '8px',
    '--sjs2-base-unit-opacity': '1%',
    '--sjs2-base-unit-scale': '1%',
    '--sjs2-scale-x000': 'calc(var(--sjs2-base-unit-scale) * 0)',
    '--sjs2-scale-x025': 'calc(var(--sjs2-base-unit-scale) * 25)',
    '--sjs2-scale-x050': 'calc(var(--sjs2-base-unit-scale) * 50)',
    '--sjs2-scale-x075': 'calc(var(--sjs2-base-unit-scale) * 75)',
    '--sjs2-scale-x095': 'calc(var(--sjs2-base-unit-scale) * 95)',
    '--sjs2-scale-x098': 'calc(var(--sjs2-base-unit-scale) * 98)',
    '--sjs2-scale-x100': 'calc(var(--sjs2-base-unit-scale) * 100)',
    '--sjs2-scale-x200': 'calc(var(--sjs2-base-unit-scale) * 200)',
    '--sjs2-size-x000': 'calc(var(--sjs2-base-unit-size) * 0)',
    '--sjs2-size-x025': 'calc(var(--sjs2-base-unit-size) * 0.25)',
    '--sjs2-size-x050': 'calc(var(--sjs2-base-unit-size) * 0.50)',
    '--sjs2-size-x075': 'calc(var(--sjs2-base-unit-size) * 0.75)',
    '--sjs2-size-x100': 'calc(var(--sjs2-base-unit-size) * 1)',
    '--sjs2-size-x125': 'calc(var(--sjs2-base-unit-size) * 1.25)',
    '--sjs2-size-x150': 'calc(var(--sjs2-base-unit-size) * 1.50)',
    '--sjs2-size-x200': 'calc(var(--sjs2-base-unit-size) * 2)',
    '--sjs2-size-x250': 'calc(var(--sjs2-base-unit-size) * 2.50)',
    '--sjs2-size-x300': 'calc(var(--sjs2-base-unit-size) * 3)',
    '--sjs2-size-x350': 'calc(var(--sjs2-base-unit-size) * 3.50)',
    '--sjs2-size-x400': 'calc(var(--sjs2-base-unit-size) * 4)',
    '--sjs2-size-x500': 'calc(var(--sjs2-base-unit-size) * 5)',
    '--sjs2-size-x600': 'calc(var(--sjs2-base-unit-size) * 6)',
    '--sjs2-size-x700': 'calc(var(--sjs2-base-unit-size) * 7)',
    '--sjs2-size-x800': 'calc(var(--sjs2-base-unit-size) * 8)',
    '--sjs2-size-x900': 'calc(var(--sjs2-base-unit-size) * 9)',
    '--sjs2-size-x1000': 'calc(var(--sjs2-base-unit-size) * 10)',
    '--sjs2-size-x1100': 'calc(var(--sjs2-base-unit-size) * 11)',
    '--sjs2-size-x1200': 'calc(var(--sjs2-base-unit-size) * 12)',
    '--sjs2-size-x1300': 'calc(var(--sjs2-base-unit-size) * 13)',
    '--sjs2-size-x1400': 'calc(var(--sjs2-base-unit-size) * 14)',
    '--sjs2-size-x1500': 'calc(var(--sjs2-base-unit-size) * 15)',
    '--sjs2-radius-x000': 'calc(var(--sjs2-base-unit-radius) * 0)',
    '--sjs2-radius-x025': 'calc(var(--sjs2-base-unit-radius) * 0.25)',
    '--sjs2-radius-x050': 'calc(var(--sjs2-base-unit-radius) * 0.50)',
    '--sjs2-radius-x075': 'calc(var(--sjs2-base-unit-radius) * 0.75)',
    '--sjs2-radius-x100': 'calc(var(--sjs2-base-unit-radius) * 1)',
    '--sjs2-radius-x125': 'calc(var(--sjs2-base-unit-radius) * 1.25)',
    '--sjs2-radius-x150': 'calc(var(--sjs2-base-unit-radius) * 1.50)',
    '--sjs2-radius-x200': 'calc(var(--sjs2-base-unit-radius) * 2)',
    '--sjs2-radius-x250': 'calc(var(--sjs2-base-unit-radius) * 2.50)',
    '--sjs2-radius-x300': 'calc(var(--sjs2-base-unit-radius) * 3)',
    '--sjs2-radius-x400': 'calc(var(--sjs2-base-unit-radius) * 4)',
    '--sjs2-radius-x500': 'calc(var(--sjs2-base-unit-radius) * 5)',
    '--sjs2-radius-x600': 'calc(var(--sjs2-base-unit-radius) * 6)',
    '--sjs2-radius-x700': 'calc(var(--sjs2-base-unit-radius) * 7)',
    '--sjs2-radius-x800': 'calc(var(--sjs2-base-unit-radius) * 8)',
    '--sjs2-radius-round': '9999px',
    '--sjs2-spacing-x000': 'calc(var(--sjs2-base-unit-spacing) * 0)',
    '--sjs2-spacing-x025': 'calc(var(--sjs2-base-unit-spacing) * 0.25)',
    '--sjs2-spacing-x050': 'calc(var(--sjs2-base-unit-spacing) * 0.50)',
    '--sjs2-spacing-x075': 'calc(var(--sjs2-base-unit-spacing) * 0.75)',
    '--sjs2-spacing-x100': 'calc(var(--sjs2-base-unit-spacing) * 1)',
    '--sjs2-spacing-x125': 'calc(var(--sjs2-base-unit-spacing) * 1.25)',
    '--sjs2-spacing-x150': 'calc(var(--sjs2-base-unit-spacing) * 1.5)',
    '--sjs2-spacing-x200': 'calc(var(--sjs2-base-unit-spacing) * 2)',
    '--sjs2-spacing-x250': 'calc(var(--sjs2-base-unit-spacing) * 2.50)',
    '--sjs2-spacing-x300': 'calc(var(--sjs2-base-unit-spacing) * 3)',
    '--sjs2-spacing-x400': 'calc(var(--sjs2-base-unit-spacing) * 4)',
    '--sjs2-spacing-x500': 'calc(var(--sjs2-base-unit-spacing) * 5)',
    '--sjs2-spacing-x550': 'calc(var(--sjs2-base-unit-spacing) * 5.5)',
    '--sjs2-spacing-x600': 'calc(var(--sjs2-base-unit-spacing) * 6)',
    '--sjs2-spacing-x700': 'calc(var(--sjs2-base-unit-spacing) * 7)',
    '--sjs2-spacing-x800': 'calc(var(--sjs2-base-unit-spacing) * 8)',
    '--sjs2-spacing-negative-x025': 'calc(var(--sjs2-base-unit-spacing) * -0.25)',
    '--sjs2-spacing-negative-x050': 'calc(var(--sjs2-base-unit-spacing) * -0.50)',
    '--sjs2-spacing-negative-x075': 'calc(var(--sjs2-base-unit-spacing) * -0.75)',
    '--sjs2-spacing-negative-x100': 'calc(var(--sjs2-base-unit-spacing) * -1)',
    '--sjs2-spacing-negative-x125': 'calc(var(--sjs2-base-unit-spacing) * -1.25)',
    '--sjs2-spacing-negative-x150': 'calc(var(--sjs2-base-unit-spacing) * -1.5)',
    '--sjs2-spacing-negative-x200': 'calc(var(--sjs2-base-unit-spacing) * -2)',
    '--sjs2-spacing-negative-x250': 'calc(var(--sjs2-base-unit-spacing) * -2.50)',
    '--sjs2-spacing-negative-x300': 'calc(var(--sjs2-base-unit-spacing) * -3)',
    '--sjs2-spacing-negative-x400': 'calc(var(--sjs2-base-unit-spacing) * -4)',
    '--sjs2-spacing-negative-x500': 'calc(var(--sjs2-base-unit-spacing) * -5)',
    '--sjs2-spacing-negative-x600': 'calc(var(--sjs2-base-unit-spacing) * -6)',
    '--sjs2-spacing-negative-x700': 'calc(var(--sjs2-base-unit-spacing) * -7)',
    '--sjs2-spacing-negative-x800': 'calc(var(--sjs2-base-unit-spacing) * -8)',
    '--sjs2-opacity-x000': 'calc(var(--sjs2-base-unit-opacity) * 0)',
    '--sjs2-opacity-x005': 'calc(var(--sjs2-base-unit-opacity) * 5)',
    '--sjs2-opacity-x010': 'calc(var(--sjs2-base-unit-opacity) * 10)',
    '--sjs2-opacity-x015': 'calc(var(--sjs2-base-unit-opacity) * 15)',
    '--sjs2-opacity-x020': 'calc(var(--sjs2-base-unit-opacity) * 20)',
    '--sjs2-opacity-x025': 'calc(var(--sjs2-base-unit-opacity) * 25)',
    '--sjs2-opacity-x030': 'calc(var(--sjs2-base-unit-opacity) * 30)',
    '--sjs2-opacity-x035': 'calc(var(--sjs2-base-unit-opacity) * 35)',
    '--sjs2-opacity-x040': 'calc(var(--sjs2-base-unit-opacity) * 40)',
    '--sjs2-opacity-x045': 'calc(var(--sjs2-base-unit-opacity) * 45)',
    '--sjs2-opacity-x050': 'calc(var(--sjs2-base-unit-opacity) * 50)',
    '--sjs2-opacity-x055': 'calc(var(--sjs2-base-unit-opacity) * 55)',
    '--sjs2-opacity-x060': 'calc(var(--sjs2-base-unit-opacity) * 60)',
    '--sjs2-opacity-x065': 'calc(var(--sjs2-base-unit-opacity) * 65)',
    '--sjs2-opacity-x070': 'calc(var(--sjs2-base-unit-opacity) * 70)',
    '--sjs2-opacity-x075': 'calc(var(--sjs2-base-unit-opacity) * 75)',
    '--sjs2-opacity-x080': 'calc(var(--sjs2-base-unit-opacity) * 80)',
    '--sjs2-opacity-x085': 'calc(var(--sjs2-base-unit-opacity) * 85)',
    '--sjs2-opacity-x090': 'calc(var(--sjs2-base-unit-opacity) * 90)',
    '--sjs2-opacity-x095': 'calc(var(--sjs2-base-unit-opacity) * 95)',
    '--sjs2-opacity-x100': 'calc(var(--sjs2-base-unit-opacity) * 100)',
    '--sjs2-border-width-x000': 'calc(var(--sjs2-base-unit-border-width) * 0)',
    '--sjs2-border-width-x100': 'calc(var(--sjs2-base-unit-border-width) * 1)',
    '--sjs2-border-width-x200': 'calc(var(--sjs2-base-unit-border-width) * 2)',
    '--sjs2-border-width-x400': 'calc(var(--sjs2-base-unit-border-width) * 4)',
    '--sjs2-font-weight-regular': '400',
    '--sjs2-font-weight-medium': '500',
    '--sjs2-font-weight-semibold': '600',
    '--sjs2-font-weight-bold': '700',
    '--sjs2-font-size-x000': 'calc(var(--sjs2-base-unit-font-size) * 0)',
    '--sjs2-font-size-x100': 'calc(var(--sjs2-base-unit-font-size) * 1)',
    '--sjs2-font-size-x150': 'calc(var(--sjs2-base-unit-font-size) * 1.5)',
    '--sjs2-font-size-x200': 'calc(var(--sjs2-base-unit-font-size) * 2)',
    '--sjs2-font-size-x250': 'calc(var(--sjs2-base-unit-font-size) * 2.5)',
    '--sjs2-font-size-x300': 'calc(var(--sjs2-base-unit-font-size) * 3)',
    '--sjs2-font-size-x350': 'calc(var(--sjs2-base-unit-font-size) * 3.5)',
    '--sjs2-font-size-x400': 'calc(var(--sjs2-base-unit-font-size) * 4)',
    '--sjs2-font-size-x500': 'calc(var(--sjs2-base-unit-font-size) * 5)',
    '--sjs2-font-size-x600': 'calc(var(--sjs2-base-unit-font-size) * 6)',
    '--sjs2-line-height-x000': 'calc(var(--sjs2-base-unit-line-height) * 0)',
    '--sjs2-line-height-x100': 'calc(var(--sjs2-base-unit-line-height) * 1)',
    '--sjs2-line-height-x200': 'calc(var(--sjs2-base-unit-line-height) * 2)',
    '--sjs2-line-height-x300': 'calc(var(--sjs2-base-unit-line-height) * 3)',
    '--sjs2-line-height-x400': 'calc(var(--sjs2-base-unit-line-height) * 4)',
    '--sjs2-line-height-x500': 'calc(var(--sjs2-base-unit-line-height) * 5)',
    '--sjs2-line-height-x600': 'calc(var(--sjs2-base-unit-line-height) * 6)',
    '--sjs2-text-case-default': 'none',
    '--sjs2-text-case-uppercase': 'uppercase',
    '--sjs2-typography-font-family-text': 'Open Sans',
    '--sjs2-typography-font-family-code': 'DM Mono',
    '--sjs2-typography-font-family-component-input-content': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-question-title': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-question-description': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-page-title': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-page-description': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-header-title': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-family-component-header-description': 'var(--sjs2-typography-font-family-text)',
    '--sjs2-typography-font-size-small': 'var(--sjs2-font-size-x150)',
    '--sjs2-typography-font-size-default': 'var(--sjs2-font-size-x200)',
    '--sjs2-typography-font-size-medium': 'var(--sjs2-font-size-x300)',
    '--sjs2-typography-font-size-large': 'var(--sjs2-font-size-x400)',
    '--sjs2-typography-font-size-component-input-content': 'var(--sjs2-typography-font-size-default)',
    '--sjs2-typography-font-size-component-question-title': 'var(--sjs2-typography-font-size-default)',
    '--sjs2-typography-font-size-component-question-description': 'var(--sjs2-typography-font-size-default)',
    '--sjs2-typography-font-size-component-page-title': 'var(--sjs2-typography-font-size-medium)',
    '--sjs2-typography-font-size-component-page-description': 'var(--sjs2-typography-font-size-default)',
    '--sjs2-typography-font-size-component-header-title': 'var(--sjs2-typography-font-size-large)',
    '--sjs2-typography-font-size-component-header-description': 'var(--sjs2-typography-font-size-medium)',
    '--sjs2-typography-line-height-small': 'var(--sjs2-line-height-x200)',
    '--sjs2-typography-line-height-default': 'var(--sjs2-line-height-x300)',
    '--sjs2-typography-line-height-medium': 'var(--sjs2-line-height-x400)',
    '--sjs2-typography-line-height-large': 'var(--sjs2-line-height-x500)',
    '--sjs2-typography-line-height-component-input-content': 'var(--sjs2-typography-line-height-default)',
    '--sjs2-typography-line-height-component-question-title': 'var(--sjs2-typography-line-height-default)',
    '--sjs2-typography-line-height-component-question-description': 'var(--sjs2-typography-line-height-default)',
    '--sjs2-typography-line-height-component-page-title': 'var(--sjs2-typography-line-height-medium)',
    '--sjs2-typography-line-height-component-page-description': 'var(--sjs2-typography-line-height-default)',
    '--sjs2-typography-line-height-component-header-title': 'var(--sjs2-typography-line-height-large)',
    '--sjs2-typography-line-height-component-header-description': 'var(--sjs2-typography-line-height-medium)',
    '--sjs2-typography-font-weight-basic': 'var(--sjs2-font-weight-regular)',
    '--sjs2-typography-font-weight-strong': 'var(--sjs2-font-weight-semibold)',
    '--sjs2-typography-font-weight-component-input-content': 'var(--sjs2-typography-font-weight-basic)',
    '--sjs2-typography-font-weight-component-question-title': 'var(--sjs2-typography-font-weight-strong)',
    '--sjs2-typography-font-weight-component-question-description': 'var(--sjs2-typography-font-weight-basic)',
    '--sjs2-typography-font-weight-component-page-title': 'var(--sjs2-typography-font-weight-strong)',
    '--sjs2-typography-font-weight-component-page-description': 'var(--sjs2-typography-font-weight-basic)',
    '--sjs2-typography-font-weight-component-header-title': 'var(--sjs2-typography-font-weight-strong)',
    '--sjs2-typography-font-weight-component-header-description': 'var(--sjs2-typography-font-weight-basic)',
    '--sjs2-is-panelless': 'false',
    '--sjs2-pdf-radius-question': 'var(--sjs2-radius-x000)',
    '--sjs2-pdf-radius-matrix': 'var(--sjs2-radius-x000)',
    '--sjs2-pdf-radius-checkbox': 'var(--sjs2-radius-x000)',
    '--sjs2-pdf-radius-radio': 'var(--sjs2-radius-round)',
    '--sjs2-pdf-radius-section': 'var(--sjs2-radius-x000)',
    '--sjs2-pdf-border-width-section': 'var(--sjs2-border-width-x100)',
    '--sjs2-pdf-border-width-question': 'var(--sjs2-border-width-x100)',
    '--sjs2-pdf-border-width-check': 'var(--sjs2-border-width-x100)',
    '--sjs2-pdf-layout-page-padding-top': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-bottom': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-left': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-right': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-gap-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-page-gap-horizontal': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-page-questions-gap-horizontal': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-page-questions-gap-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-page-matrix-gap-horizontal': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-page-matrix-gap-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-title-large-gap': 'var(--sjs2-spacing-x150)',
    '--sjs2-pdf-layout-title-large-padding-bottom': 'var(--sjs2-spacing-x400)',
    '--sjs2-pdf-layout-title-medium-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-title-medium-padding-bottom': 'var(--sjs2-spacing-x300)',
    '--sjs2-pdf-layout-title-default-gap': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-title-default-padding-bottom': 'var(--sjs2-spacing-x150)',
    '--sjs2-pdf-layout-section-padding-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-section-padding-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-section-gap': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-check-padding-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-check-padding-horizontal': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-check-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-matrix-padding-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-matrix-padding-horizontal': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-matrix-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-padding-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-padding-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-labels-gap-vertical': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-question-items-gap-vertical': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-question-items-gap-horizontal': 'var(--sjs2-spacing-x150)',
    '--sjs2-pdf-layout-image-picker-items-gap-image-check': 'var(--sjs2-spacing-x000)'
};
